/**
 * Configuration Interface
 */
export interface IConfig {
  api: {
    baseUrl: string;
    aiBaseUrl: string;
    apiKey: string;
    stripePublishableKey: string;
    shareTribeBaseUrl : string;
    shareTribe_client_id : string;
    shareTribe_client_secret : string;
    stripeBaseUrl?: string;
  };
  payment: {
    links: {
      swimmer: {
        monthly: string;
        yearly: string;
      };
      coach: {
        monthly: string;
        yearly: string;
      };
    };
  };
  auth: {
    tokenKey: string;
   // userDataKey: string;
    tokenExpiryHours: number;
  };
  app: {
    name: string;
    version: string;
    environment: 'development' | 'production' | 'test';
  };
  logging: {
    level: 'debug' | 'info' | 'warn' | 'error';
    enableConsole: boolean;
  };
}

/**
 * Configuration Manager
 * Follows Singleton Pattern for global configuration
 */
export class ConfigManager {
  private static instance: ConfigManager | null = null;
  private config: IConfig;

  private constructor() {
    this.config = this.loadConfig();
  }

  static getInstance(): ConfigManager {
    if (!this.instance) {
      this.instance = new ConfigManager();
    }
    return this.instance;
  }

  getConfig(): IConfig {
    return { ...this.config };
  }

  getApiConfig() {
    return { ...this.config.api };
  }

  getAuthConfig() {
    return { ...this.config.auth };
  }

  getAppConfig() {
    return { ...this.config.app };
  }

  getLoggingConfig() {
    return { ...this.config.logging };
  }

  getPaymentConfig() {
    return { ...this.config.payment };
  }

  private loadConfig(): IConfig {
    const isDevelopment = import.meta.env.DEV;
    const isProduction = import.meta.env.PROD;

    return {
      api: {
        // Use proxy in both dev and production to avoid CORS issues
        baseUrl: '/api',
        aiBaseUrl: '/ai-api',
        apiKey: 'g78901efgh234ijk3456',
        stripePublishableKey: 'pk_test_FsyuvyOTih6BCHbpzDTq4Gcw',
        shareTribeBaseUrl : 'https://flex-api.sharetribe.com/v1',
        shareTribe_client_id : 'f5f5fbdd-58e3-4fea-bb34-84afc06d8c12',
        shareTribe_client_secret : '55cb45cf21276bb53e9123ef7681c136ad44dc07',
        stripeBaseUrl: '/stripe',
      },
      payment: {
        links: {
          swimmer: {
            monthly: '',
            yearly: '',
          },
          coach: {
            monthly: '',
            yearly: '',
          },
        },
      },
      auth: {
        tokenKey: 'auth_token',
        //userDataKey: 'user_data',
        tokenExpiryHours: 24
      },
      app: {
        name: 'Swimnerd',
        version: '1.0.0',
        environment: isDevelopment ? 'development' : isProduction ? 'production' : 'test'
      },
      logging: {
        level: isDevelopment ? 'debug' : 'error',
        enableConsole: true
      }
    };
  }

  updateConfig(updates: Partial<IConfig>): void {
    this.config = { ...this.config, ...updates };
  }
}
